import React, { useEffect, useState } from "react";
import {
  Layout,
  Row,
  Col,
  Menu,
  Image,
  Typography,
  Collapse,
  Button,
  Card,
} from "antd";
import { mockData } from "./mock";
import Percent from "@assets/KPMG/percent.svg";
import Rating from "@assets/KPMG/rating.svg";
import Location from "@assets/KPMG/location.svg";
import { Fade } from "react-awesome-reveal";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";

interface Props {}

const { Panel } = Collapse;

export const TabInfo = ({}: Props) => {
  const [selectedContent, setSelectedContent] = useState<any>({});
  useEffect(() => {
    setSelectedContent(mockData);
  }, []);

  const navigate = useNavigate();
  return (
    <>
      <Fade triggerOnce direction="up">
        {selectedContent && (
          <div className="faqListPage">
            <div style={{ marginRight: 180 }}>
              <Row gutter={[32, 32]}>
                <Col span={24}>
                  {selectedContent.faqList &&
                    selectedContent.faqList.map((item: any, index: number) => {
                      return (
                        <div style={{ borderBottom: "1px solid #fff" }}>
                          <Row
                            style={{ paddingTop: 14, paddingBottom: 14, cursor : "pointer" }}
                            onClick={(e) => {
                              localStorage.setItem(
                                "selectedFAQ",
                                item.question
                              );
                              navigate("/knowledge-hub");
                            }}
                          >
                            <Col span={2}>
                              <Typography.Text
                                className="mb-0"
                                style={{
                                  color: "#fff",
                                  paddingLeft: 20,
                                  fontSize: 16,
                                }}
                              >
                                {item.sNo}
                              </Typography.Text>
                            </Col>
                            <Col span={20}>
                              <Typography.Text
                                className="mb-0"
                                style={{ color: "#fff", fontSize: 16 }}
                              >
                                {item.question}
                              </Typography.Text>
                            </Col>
                            <Col
                              span={2}
                              style={{
                                paddingRight: 20,
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Icon
                                icon={"uis:angle-right"}
                                style={{
                                  fontSize: 32,
                                  color: "#fff",
                                }}
                              />
                            </Col>
                          </Row>
                        </div>
                      );
                    })}
                  {/* <Collapse
                    accordion
                    expandIconPosition="end"
                    className="faqList"
                  >
                    {selectedContent.faqList &&
                      selectedContent.faqList.map(
                        (item: any, index: number) => {
                          return (
                            <Panel
                              header={
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div style={{ width: 80 }}>
                                      <Typography.Title
                                        level={3}
                                        className="mb-0"
                                        style={{ color: "#fff" }}
                                      >
                                        {item.sNo}
                                      </Typography.Title>
                                    </div>
                                    <Typography.Text
                                      className="mb-0"
                                      style={{ color: "#fff" }}
                                    >
                                      {item.question}
                                    </Typography.Text>
                                  </div>
                                </>
                              }
                              key={`${index}`}
                            >
                              <Typography.Text
                                style={{ color: "#fff", marginLeft: 80 }}
                                className="text"
                              >
                                <>{item.answer}</>
                              </Typography.Text>
                            </Panel>
                          );
                        }
                      )}
                  </Collapse> */}
                </Col>
              </Row>
              <div
                style={{
                  paddingTop: 60,
                  paddingBottom: 120,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  type="primary"
                  style={{
                    border: "1px solid #fff",
                    background: "transparent",
                    height: 40,
                    padding: "12px 24px",
                  }}
                  onClick={() => navigate("/faq")}
                >
                  View More FAQs
                </Button>
              </div>
            </div>
          </div>
        )}
      </Fade>
    </>
  );
};
